import { Outlet } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { MyCardsDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import Content from 'modules/expenses/components/cards/PageContents/MyCardsContent'
import { useCardsCreation } from 'modules/expenses/hooks/useCardsCreationLimits'

const MyCardsPage = () => {
  const { navigation } = useNavigation()
  const { employee } = useCurrentSession()

  useEffect(() => {
    track(trackingEvents.procurement.openMyPurchaseRequests)
  }, [])

  const { data } = useQuery(MyCardsDocument, {
    variables: {
      employeeId: Number(employee?.id),
    },
    skip: !employee,
    errorPolicy: 'all',
  })

  const { canCreateCard } = useCardsCreation()

  const cards = data?.banking.cardsConnection?.nodes || []
  const canRequestSingleUseCards =
    !!data?.expenses?._policies?.cardRequestSingleUseCards?.can || false
  const canCreateSingleUseCard = canCreateCard('single_use') && canRequestSingleUseCards

  return (
    <>
      {canRequestSingleUseCards && (
        <Box alignItems="flexEnd" paddingBottom="s8">
          <Button.Router
            iconName="add"
            to={navigation.myCards.requestCard.fullPath()}
            onClick={() => {
              track(trackingEvents.expenses.gotToCreateCard)
            }}
            disabled={!canCreateSingleUseCard}
          >
            {i18n.t('expenses_v2.buttons.request_single_use_card')}
          </Button.Router>
        </Box>
      )}
      <Content cards={cards} canCreateSingleUseCard={canCreateSingleUseCard} />
      <Outlet />
    </>
  )
}

export default MyCardsPage
